import React from "react";
import {t} from "i18next";

export class NotFound extends React.Component {
    render() {
        return <h1 style={{textAlign: "center", paddingTop: "10%"}}>{t("404.desc")}</h1>;
    }
}
